import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

export interface Team {
  id: string;
  company_id: string;
  name: string;
  description?: string | null;
  created_by: string;
  is_active: boolean;
  created_at: string;
  updated_at?: string | null;
  member_count: number;
  created_by_name: string;
}

export interface TeamMember {
  id: string;
  team_id: string;
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
}

export interface TeamWithMembers extends Team {
  members: TeamMember[];
}

function authHeaders(token: string) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function listTeams(token: string): Promise<Team[]> {
  const response = await axios.get(`${API_BASE_URL}/teams`, authHeaders(token));
  return response.data.data;
}

export async function getTeamById(id: string, token: string): Promise<TeamWithMembers> {
  const response = await axios.get(`${API_BASE_URL}/teams/${id}`, authHeaders(token));
  return response.data.data;
}

export async function createTeam(data: { name: string; description?: string }, token: string): Promise<Team> {
  const response = await axios.post(`${API_BASE_URL}/teams`, data, authHeaders(token));
  return response.data.data;
}

export async function updateTeam(id: string, data: { name?: string; description?: string }, token: string): Promise<Team> {
  const response = await axios.put(`${API_BASE_URL}/teams/${id}`, data, authHeaders(token));
  return response.data.data;
}

export async function deleteTeam(id: string, token: string): Promise<void> {
  await axios.delete(`${API_BASE_URL}/teams/${id}`, authHeaders(token));
}

export async function setTeamMembers(teamId: string, userIds: string[], token: string): Promise<TeamMember[]> {
  const response = await axios.put(`${API_BASE_URL}/teams/${teamId}/members`, { userIds }, authHeaders(token));
  return response.data.data;
}
